import { render } from "./CategoryItemNew.vue?vue&type=template&id=6c0c640d&scoped=true"
import script from "./CategoryItemNew.vue?vue&type=script&lang=js"
export * from "./CategoryItemNew.vue?vue&type=script&lang=js"

import "./CategoryItemNew.vue?vue&type=style&index=0&id=6c0c640d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c0c640d"]])

export default __exports__